/**
 * @generated SignedSource<<6fb72924017dbc1e00269df11b14755b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactViewQuery$variables = {
  id: string;
};
export type ContactViewQuery$data = {
  readonly contact: {
    readonly __typename: string;
    readonly familyName?: string;
    readonly givenName?: string;
    readonly id: string;
    readonly teamName?: string;
    readonly " $fragmentSpreads": FragmentRefs<"ContactActivityView_contact" | "ContactContactView_contact" | "ContactDataProtectionView_contact" | "ContactHeader_contact" | "ContactMarketingView_contact">;
  } | null | undefined;
};
export type ContactViewQuery = {
  response: ContactViewQuery$data;
  variables: ContactViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "givenName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "familyName",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    }
  ],
  "type": "TeamContact",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "contact",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "type": "PersonContact",
            "abstractKey": null
          },
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactHeader_contact"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactContactView_contact"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactActivityView_contact"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactDataProtectionView_contact"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactMarketingView_contact"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContactViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "contact",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isContact"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailAddress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "preferredLanguage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactCustomerAccountConnection",
            "kind": "LinkedField",
            "name": "customerAccounts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContactCustomerAccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAccount",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAccountContactRole",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roleIdentifier",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "label",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "en",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "de",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ContactAttribute",
            "kind": "LinkedField",
            "name": "attributes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "salutation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "DataOrigin",
                "kind": "LinkedField",
                "name": "dataOrigins",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "collectedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "note",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PersonContact",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "883d16900555af58503524880261aba2",
    "id": null,
    "metadata": {},
    "name": "ContactViewQuery",
    "operationKind": "query",
    "text": "query ContactViewQuery(\n  $id: ID!\n) {\n  contact(id: $id) {\n    __typename\n    id\n    ... on PersonContact {\n      givenName\n      familyName\n    }\n    ... on TeamContact {\n      teamName\n    }\n    ...ContactHeader_contact\n    ...ContactContactView_contact\n    ...ContactActivityView_contact\n    ...ContactDataProtectionView_contact\n    ...ContactMarketingView_contact\n  }\n}\n\nfragment ContactActivityView_contact on Contact {\n  __isContact: __typename\n  id\n  contactIdentifier\n}\n\nfragment ContactAttributesPanel_contact on Contact {\n  __isContact: __typename\n  id\n  attributes {\n    name\n    value\n  }\n}\n\nfragment ContactContactView_contact on Contact {\n  __isContact: __typename\n  __typename\n  id\n  contactIdentifier\n  ...ContactDataList_contact\n  ...ContactCustomersPanel_contact\n  ...ContactAttributesPanel_contact\n  ...DeleteContactDialog_contact\n}\n\nfragment ContactCustomersPanel_contact on Contact {\n  __isContact: __typename\n  customerAccounts {\n    totalCount\n    edges {\n      node {\n        id\n        customerName\n      }\n      roles {\n        roleIdentifier\n        label {\n          en\n          de\n        }\n      }\n    }\n  }\n}\n\nfragment ContactDataList_contact on Contact {\n  __isContact: __typename\n  id\n  __typename\n  ... on PersonContact {\n    salutation\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n  emailAddress\n  phoneNumber\n  preferredLanguage\n  ...UpdatePersonContactDialog_contact\n  ...UpdateTeamContactDialogProps_contact\n  ...SetContactPreferredLanguageDialog_contact\n}\n\nfragment ContactDataOriginList_contact on Contact {\n  __isContact: __typename\n  __typename\n  id\n  ... on PersonContact {\n    dataOrigins {\n      description\n      collectedAt\n      note\n    }\n  }\n}\n\nfragment ContactDataProtectionView_contact on Contact {\n  __isContact: __typename\n  __typename\n  id\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n  ...ContactDataOriginList_contact\n}\n\nfragment ContactHeader_contact on Contact {\n  __isContact: __typename\n  id\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n}\n\nfragment ContactMarketingView_contact on Contact {\n  __isContact: __typename\n  __typename\n  id\n  contactIdentifier\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n}\n\nfragment DeleteContactDialog_contact on Contact {\n  __isContact: __typename\n  id\n  ... on PersonContact {\n    givenName\n    familyName\n  }\n  ... on TeamContact {\n    teamName\n  }\n}\n\nfragment SetContactPreferredLanguageDialog_contact on Contact {\n  __isContact: __typename\n  id\n  preferredLanguage\n}\n\nfragment UpdatePersonContactDialog_contact on PersonContact {\n  id\n  salutation\n  givenName\n  familyName\n  emailAddress\n  phoneNumber\n}\n\nfragment UpdateTeamContactDialogProps_contact on TeamContact {\n  id\n  teamName\n  emailAddress\n  phoneNumber\n}\n"
  }
};
})();

(node as any).hash = "51bc9a966810d41687edddce3d1a05b9";

export default node;
